const { createContext, useState, useEffect } = require("react");


export const DeviceContext = createContext();

export const DeviceProvider = ({ children }) => {

    const [isMobile, setMobile] = useState(true);

    useEffect(() => {
        if (window.innerWidth > 1030) {
            setMobile(false);
        } else {
            setMobile(true);
        }
        const handleWindowResize = () => {
            if (window.innerWidth > 1030) {
                setMobile(false);
            } else {
                setMobile(true);
            }
        };
        window.addEventListener("resize", handleWindowResize);
        return () => window.removeEventListener("resize", handleWindowResize);
    }, []);


    return (
        <>
            <DeviceContext.Provider value={{ isMobile }}>
                {children}
            </DeviceContext.Provider>
        </>
    )
};


export default DeviceProvider;